export const roleSequence: string[] = ['free', 'starter', 'foundation', 'premium', 'invest', 'pro', 'premium_plus', 'professional'];
